import {
  Box,
  Button,
  getThemeColor,
  Input as DSInput,
} from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const TruncatedText = styled(Box)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  max-width: 180px;
`

export const SendTraceabilityButton = styled(Button)`
  background: ${({ theme }) =>
    `linear-gradient(304deg, ${getThemeColor('secondary', theme)} -1.45%, ${getThemeColor('primary', theme)} 103.12%);`};
  gap: 12px;
`

export const RequiredInput = styled(DSInput)<{ isEmpty?: boolean }>`
  ${({ isEmpty, theme }) => {
    if (isEmpty)
      return `
      border: 1.5px solid ${getThemeColor('error', theme)};
      background-color: ${getThemeColor('error', theme)}1A;
      &:focus {
        border-color: ${getThemeColor('error', theme)};
        box-shadow: 0 0 0 2px ${getThemeColor('error', theme)}1A;
      }
    `
  }}
`
